import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './PlanBox.css';

function PlanBox({ children, space, kind, isCurrent }) {
  const className = cx(styles.card, `padding-${space}`, {
    [styles.default]: kind === 'default',
    [styles.blue]: kind === 'blue',
    [styles.enterprise]: kind === 'enterprise',
    [styles.isCurrent]: isCurrent,
  });
  return <div className={className}>{children}</div>;
}

PlanBox.propTypes = {
  children: PropTypes.node.isRequired,
  isCurrent: PropTypes.bool,
  kind: PropTypes.oneOf(['default', 'blue', 'enterprise']),
  space: PropTypes.string,
};

PlanBox.defaultProps = {
  isCurrent: false,
  kind: 'default',
  space: '0',
};

export default PlanBox;



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/PlanBox/index.js